<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

 // 1. Modificar textos y añadir ícono funcional
document.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(label => {
  const textContent = label.textContent.trim();
  
  // Modificar Compra única
  if (textContent.includes('Compra única')) {
    label.querySelector('label').innerHTML = label.querySelector('label').innerHTML
      .replace('Compra única', 'Solo una vez');
  }
  
  // Modificar Suscríbete y ahorra
  if (textContent.includes('Suscríbete y ahorra')) {
    const container = label.querySelector('.shopify_subscriptions_purchase_option_wrapper > label');
    container.innerHTML = `
      <span style="position: relative; padding-right: 25px;">
        Suscríbete y ahorra un 15%
      </span>
    `;
  }
});
  

// Cambiar solo el texto visible manteniendo el input
document.querySelectorAll('.shopify_subscriptions_app_block_label_children label').forEach(label => {
  Array.from(label.childNodes).forEach(node => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Entrega cada')) {
      node.textContent = node.textContent.replace('Entrega cada', 'Las quiero cada')
    }
  });
  
  // Actualizar también el aria-label del input
  const input = label.querySelector('input');
  if (input) {
    const newAriaLabel = input.getAttribute('aria-label')
                            .replace('Entrega cada', 'Lo quiero cada')
                            .replace('Product price', 'Precio del producto');
    input.setAttribute('aria-label', newAriaLabel);
  }
});

// Eliminar ", 15% de descuento" manteniendo los radio buttons
document.querySelectorAll('.shopify_subscriptions_app_block_label label').forEach(label => {
  // Crear un nuevo elemento temporal
  const tempDiv = document.createElement('div');
  
  // Clonar el contenido original
  const clonedLabel = label.cloneNode(true);
  
  // Modificar solo el texto
  Array.from(clonedLabel.childNodes).forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace(/, 15% de descuento/g, '');
    }
  });
  
  // Reemplazar el aria-label en el input
  const input = clonedLabel.querySelector('input');
  if (input) {
    const ariaLabel = input.getAttribute('aria-label').replace(/, 15% de descuento/g, '');
    input.setAttribute('aria-label', ariaLabel);
  }
  
  // Reemplazar el label original con el modificado
  tempDiv.appendChild(clonedLabel);
  label.replaceWith(tempDiv.firstChild);
});





// 3. Mover y configurar el badge
const badge = document.getElementById('subscriptions_badge_text');
if (badge) {
  badge.style.cssText = `
    display: inline-block !important;
    position: relative;
    margin-left: 8px;
    vertical-align: middle;
    cursor: help;
  `;
  
  // Mover el badge junto al precio de suscripción
  const priceElement = document.querySelector('.allocation_price');
  if (priceElement) {
    priceElement.parentNode.insertBefore(badge, priceElement.nextSibling);
  }
  
  // Ocultar texto original y mostrar solo ícono
  badge.innerHTML = `
  `;
}

// 4. Ocultar texto original de política
document.querySelector('.shopify_subscriptions_app_policy').style.display = 'none';